module.exports = __webpack_public_path__ + "img/img-benefit-quac-5.baf32a78.svg";